import {h} from 'preact';
import {
    iconExamsCovid,
    iconExamsLab,
    iconVaccines,
    logoNewAppleStore,
    logoNewGooglePlay,
} from "../../../assets";
import {Link} from 'preact-router/match';
import { useAppContext } from '../../../contexts';
import UpperRow from "./UpperRow";
import SocialMedia from "./SocialMedia";
import Recognitions from "./Recognitions";
import LowerRow from "./LowerRow";
import s from "./footer.module.css";

const Footer = () => {
    // Accessibility feature data
    const {highContrast} = useAppContext();

    // This is used to hide the second and the third header rows at the onboarding page
    const isOnboardingPage = window.location.pathname === "/onboarding";

    if (isOnboardingPage) {
        return null;
    }

    return (
        <footer>
            <div className={`bg-light-gray font-museo container-fluid flex flex-col text-black dark:text-white ${highContrast ? "grayBackground" : ""}`}>
                <div className=" w-full xmd:sabin-container flex flex-col xmd:justify-between xmd:py-0">
                    {/*<UpperRow />*/}
                    <div
                        className='mt-6 xmd:mt-12 flex flex-col xmd:flex-row justify-center items-center xmd:items-start w-full xmd:gap-[2rem] px-0 xmd:px-28 xmd:mb-10'>
                        <div className='grid grid-cols-2 xmd:grid-cols-4 gap-y-8 gap-x-5 xmd:gap-x-12 w-full my-6 xmd:my-0'>
                            <div className="flex flex-col justify-between font-bold gap-y-5">
                                <Link
                                    href="/exames-covid-19"
                                    className="flex items-center xmd:mb-0 gap-[0.5rem]"
                                    data-testid="footer-exams-link"
                                >
                                    <img
                                        src={iconExamsCovid}
                                        className={`dark:grayscale`}
                                        width="30"
                                        alt="ícone de exames para covid-19"
                                        data-testid="footer-exams-icon"
                                    />
                                    <span
                                        className="pl-4 text-base font-weight-bold hover:underline hover:underline-offset-2"
                                        data-testid="footer-exams-label"
                                    >
                                    Exames<br/>Covid-19
                                </span>
                                </Link>
                                <Link
                                    href="/exames-laboratoriais"
                                    className="flex items-center xmd:mb-0 gap-[0.5rem]"
                                    data-testid="footer-lab-exams-link"
                                >
                                    <img
                                        src={iconExamsLab}
                                        className={`dark:grayscale`}
                                        width="30"
                                        alt="ícone de exames laboratoriais"
                                        data-testid="footer-lab-exams-icon"
                                    />
                                    <span
                                        className="pl-4 text-base font-weight-bold hover:underline hover:underline-offset-2"
                                        data-testid="footer-lab-exams-label"
                                    >
                                    Exames<br/>Laboratoriais
                                </span>
                                </Link>
                                <Link
                                    href="/vacinas"
                                    className="flex items-center xmd:mb-0 gap-[0.5rem]"
                                    data-testid="footer-vaccine-link"
                                >
                                    <img
                                        src={iconVaccines}
                                        className={`dark:grayscale`}
                                        width="30"
                                        alt="ícone de vacinas"
                                        data-testid="footer-vaccine-icon"
                                    />
                                    <span
                                        className="pl-4 text-base font-weight-bold hover:underline hover:underline-offset-2"
                                        data-testid="footer-vaccine-label"
                                    >
                                    Vacinas
                                </span>
                                </Link>
                                <Link
                                    href="/vacinas/vacinas-para-criancas"
                                    className="flex items-center xmd:mb-0 gap-[0.5rem]"
                                    data-testid="footer-vaccine-link"
                                >
                                    <img
                                        src={iconVaccines}
                                        className={`dark:grayscale`}
                                        width="30"
                                        alt="ícone de vacinas"
                                        data-testid="footer-vaccine-icon"
                                    />
                                    <span
                                        className="pl-4 text-base font-weight-bold hover:underline hover:underline-offset-2"
                                        data-testid="footer-vaccine-label"
                                    >
                                    Pacotes infantis
                                </span>
                                </Link>
                            </div>
                            <div
                                className="flex flex-col justify-start underline underline-offset-2 gap-y-3 xmd:gap-y-6">
                                <Link
                                    href="/fale-conosco"
                                    className="flex items-center mb-3 xmd:mb-0"
                                    data-testid="footer-contact-link"
                                >
                                <span
                                    className="text-sm"
                                    data-testid="footer-contact-label"
                                >
                                    Fale Conosco
                                </span>
                                </Link>
                                <a
                                    href="https://www.sabin.com.br/unidades/"
                                    target="_blank"
                                    className="flex items-center mb-3 xmd:mb-0"
                                    data-testid="footer-units-link"
                                    rel="noreferrer"
                                >
                                <span
                                    className="text-sm"
                                    data-testid="footer-units-label"
                                >
                                    Nossas Unidades
                                </span>
                                </a>
                                <Link
                                    href="/termos-de-uso"
                                    className="flex items-center mb-3 xmd:mb-0"
                                    data-testid="footer-term-link"
                                >
                                <span
                                    className="text-sm"
                                    data-testid="footer-term-label"
                                >
                                    Termos de Uso
                                </span>
                                </Link>
                                <Link
                                    href="/perguntas-frequentes"
                                    className="flex items-center mb-3 xmd:mb-0"
                                    data-testid="footer-questions-link"
                                >
                                <span
                                    className="text-sm"
                                    data-testid="footer-questions-label"
                                >
                                    Perguntas Frequentes
                                </span>
                                </Link>
                            </div>
                            <div className='hidden xmd:flex flex-col justify-start xmd:mb-6 mt-4 xmd:mt-0 ml-[1rem] xmd:ml-0'>
                                <p
                                    className="text-[14px] m-0 xmd:mb-4"
                                    data-testid="app-label"
                                >
                                    Baixe nosso aplicativo
                                </p>
                                <div className="flex flex-col w-full justify-between gap-y-3">
                                    <a
                                        href="https://apps.apple.com/br/app/sabin-medicina-diagn%C3%B3stica/id505139714"
                                        target='_blank'
                                        data-testid="apple-app-link"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src={logoNewAppleStore}
                                            className="w-[163px] mb-2 xmd:mb-0 dark:grayscale"
                                            alt="a"
                                        />
                                    </a>
                                    <a
                                        href="https://play.google.com/store/apps/details?id=br.com.warpzone.zeroum.sabin&hl=pt_BR&gl=US"
                                        target='_blank'
                                        data-testid="android-app-link"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src={logoNewGooglePlay}
                                            className="w-[163px] dark:grayscale"
                                            width="97"
                                            alt="a"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className={s.socialsBlock}>
                                <div className="flex flex-row xmd:flex-col xmd:justify-between">
                                    <p
                                        className="text-[14px] m-0 mb-3"
                                        data-testid="contact-label"
                                    >
                                        Contato:&nbsp;
                                    </p>
                                    <div className="flex flex-col mb-2">
                                        <span
                                            className="block text-[14px] font-bold"
                                            data-testid="desktop-contact-number"
                                        >
                                            (61) 3329-8000
                                        </span>
                                    </div>
                                </div>
                                <SocialMedia />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="opacity-40" />
            <Recognitions />
            <LowerRow />
        </footer>
    )
};

export default Footer;
